.wrapper {
  width: fit-content;
}

.vertical {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  //TODO: adding this to global spacing for reuse when more components are fleshed out
  div {
    margin-bottom: .85em;
  }
}

.horizontal {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  
  div {
    margin-right: .85em;

  }
}